import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Banner from '../../components/banner';
import {Col, Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import ComponentErrorBoundary from '../../components/component-error-boundary';
import Button from '../../components/button';
import {
      updatePassword
    } from './profile.actions';
import {checkRequirements, MAX_LENGTH, REQUIREMENT_TEXT} from '../../util/password-policy';

class Profile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      newPassword:"",
      newPasswordErrorStatus:false,
      newPasswordErrorText:"",
      confirmPassword:"",
      confirmPasswordErrorStatus:false,
      confirmPasswordErrorText:"",
      passwordUpdateBtnStatus:true,
      snackbarStatus: false,
      bannerType: "danger",
      bannerTitle:"",
      bannerMessage:"",
      showBanner: false,
      actionTriggered:false,
      actionName:"",
      passwordValidation: {
        length: false,
        case: false,
        number: false
      }
    };
  }


  componentDidUpdate(prevProps) {
  if (prevProps.isLoading !== this.props.isLoading && this.state.actionTriggered === true) {
    if(this.props.isLoading.includes('updatepassword')){
     this.setState({snackbarStatus:true,actionName:"updatePassword"});
    }
    else{
      if(this.state.actionName==="updatePassword"){
        if(this.props.error.length > prevProps.error.length){
          this.setState({showBanner:true,bannerType:"danger",bannerTitle:"Error",bannerMessage:"Failed to update password. Please try again."});
        } else {
          this.updatePasswordSuccess();
        }
      }
      this.setState({snackbarStatus:false,actionTriggered:false,actionName:""});
    }
  }
}


updatePasswordSuccess=()=>{
  this.setState({showBanner:true,bannerType:"success",bannerTitle:"Done!",bannerMessage:"Your password has been updated successfully."});
  this.resetPageFields();
  this.goToTop();
}

  resetPageFields=()=>{
    this.setState({
      newPassword:"",
      confirmPassword:"",
      passwordUpdateBtnStatus:true,
      passwordValidation: {
        length: false,
        case: false,
        number: false
      }
    });
  }

  goToTop=()=>{
    document.getElementById("app").scrollTo(0,0);
  }

  checkPasswordStrength=()=>{
    const password = this.state.newPassword;

    if(password.length > 0){
      // Shared with add-user.js, edit-user.js and (mirrored) the server. These three pages each
      // carried their own copy and had drifted apart; see src/util/password-policy.js.
      const validation = checkRequirements(password);

      this.setState({ passwordValidation: validation });
      
      // Overall validation - only check on blur, not during typing
      const allValid = validation.length && validation.case && validation.number;
      
      if(allValid)
        {
        this.setState({newPasswordErrorStatus:false,newPasswordErrorText:""},()=>{this.enableUpdateButton();});
        return true;
        }
      else
        {
        // Only show error on blur, not during typing
        if(this.state.newPasswordErrorStatus){
          this.setState({newPasswordErrorText:"Password is not matching the requirements. Please check."},()=>{this.enableUpdateButton();});
        }
        return false;
        }
    } else {
      // Reset validation when password is empty
      this.setState({ 
        passwordValidation: { length: false, case: false, number: false },
        newPasswordErrorStatus: false,
        newPasswordErrorText: ""
      });
    }
  }
  
  handlePasswordBlur=()=>{
    const password = this.state.newPassword;
    if(password.length > 0){
      const allValid = this.state.passwordValidation.length && 
                      this.state.passwordValidation.case && 
                      this.state.passwordValidation.number;
      if(!allValid){
        this.setState({
          newPasswordErrorStatus:true,
          newPasswordErrorText:"Password is not matching the requirements. Please check."
        }, ()=>{this.enableUpdateButton();});
      }
    }
  }

  checkPasswordMatch=()=>{
    if(this.state.newPassword !== this.state.confirmPassword){
      this.setState({confirmPasswordErrorStatus:true,confirmPasswordErrorText:"Passwords didn't match. Please check."},()=>{this.enableUpdateButton();});
    }
    else{
      this.setState({confirmPasswordErrorStatus:false,confirmPasswordErrorText:""},()=>{this.enableUpdateButton();});
    }
  }

 enableUpdateButton=()=>{
   this.setState(prevState => {
     const shouldEnable = prevState.confirmPasswordErrorStatus === false &&
       prevState.newPasswordErrorStatus === false &&
       prevState.newPassword !== "" &&
       prevState.confirmPassword !== "";
     return { passwordUpdateBtnStatus: !shouldEnable };
   });
 }

  dismissBanner = () => {
                this.setState({showBanner:false});
         }

 snackHandler = (state) =>{
   this.setState({snackbarStatus:state});
 }


 updatePassword = () => {
   this.setState({actionTriggered:true});
   let data={
     email: localStorage.getItem('saganUsername'),
     password: this.state.newPassword,
     confirmPassword: this.state.confirmPassword,
    }
   this.props.updatePasswordRequest(data);
 }

 handleTextfield = (event,item) => {
     this.setState({[item]:event.target.value}, () => {
       if (item === 'newPassword') {
         this.checkPasswordStrength();
         if (this.state.confirmPassword !== '') {
           this.checkPasswordMatch();
         }
       }
     });
 }




   render() {
     const displayName = localStorage.getItem('saganUsername');

     return (
       <div className='app-content-container'>

       <Snackbar
           open={this.state.snackbarStatus}
           message="Please wait..."
           className="snack-bar"
         />


       <Banner
          type={this.state.bannerType}
          hasAlerts={this.state.showBanner}
          header={this.state.bannerTitle}
          body={this.state.bannerMessage}
          dismissBanner={this.dismissBanner.bind(this)}
          />

        <div className="page-content select-container in">
          <h2>Your Profile</h2>

            <Row>
              <Col sm={6} xs={12}>
              <div className='rounded-card'>
              <Row className='label-value-pair'>
                <Col sm={6} xs={12}>
                <label>Name</label>
                <div>{displayName}</div>
                </Col>
              </Row>
                </div>

                <div className='rounded-card'>
                <h4>Update Password</h4>
                <Row className='label-value-pair'>
                  <Col sm={6} xs={12}>
                <ComponentErrorBoundary value="profile create password">
                  <TextField
                      id="outlined-password-input"
                      label="New password"
                      type="password"
                      inputProps={{'maxLength': MAX_LENGTH, 'data-testid': 'profile-new-password'}}
                      value={this.state.newPassword}
                      onChange={(e)=>this.handleTextfield(e,"newPassword")}
                      onBlur={this.handlePasswordBlur}
                      error={this.state.newPasswordErrorStatus}
                      helperText={this.state.newPasswordErrorText}
                    />
                  </ComponentErrorBoundary>
                    <div className='password-requirements'>
                    <div className='title'>Password requirements:</div>
                    <ul data-testid="profile-password-requirements">
                      {['length','case','number'].map((key, i) => (
                        <li key={key} className={this.state.passwordValidation[key] ? 'valid' : ''}>
                          <span className='icon'></span>
                          <span className='text'>{REQUIREMENT_TEXT[i]}</span>
                        </li>
                      ))}
                    </ul>
                    </div>
                  </Col>
                </Row>
                <Row className='label-value-pair'>
                  <Col sm={6} xs={12}>
                <ComponentErrorBoundary value="profile re-enter password">
                  <TextField
                      id="outlined-confirmpassword-input"
                      label="Re-enter password"
                      type="password"
                      inputProps={{'maxLength': MAX_LENGTH, 'data-testid': 'profile-confirm-password'}}
                      value={this.state.confirmPassword}
                      onChange={(e)=>this.handleTextfield(e,"confirmPassword")}
                      onBlur={this.checkPasswordMatch}
                      error={this.state.confirmPasswordErrorStatus}
                      helperText={this.state.confirmPasswordErrorText}
                    />
                  </ComponentErrorBoundary>
                  </Col>
                </Row>

                <Row className='label-value-pair'>
                  <Col sm={6} xs={12}>
                  <Button
                  label="Update"
                  className='btn btn-action'
                  disabled={this.state.passwordUpdateBtnStatus}
                  onClick={this.updatePassword.bind(this)}
                   />
                  </Col>
                </Row>


                  </div>
              </Col>
            </Row>


        </div>

       </div>
     );
   }
}


const mapStateToProps = (state) => {
  return{
    isLoading:state.profileReducer.isLoading,
    error:state.profileReducer.error
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    updatePasswordRequest : (data) => {
      dispatch(updatePassword(data));
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps) (Profile);
